module.exports = __webpack_public_path__ + "static/media/aboutUs.8a1238cc.png";